module.exports = __webpack_public_path__ + "static/media/mentions.0d025cf2.md";